/* eslint-disable max-len */

export default {
  lang: 'English',
  homeScreen: {
    title: '', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
    messages: 'Messages',
  },
  glassWidgets: {
    errors: {
      requestFailed: 'Something went wrong. Please try again later.',
    },
    programStatus: {
      title: 'My Status',
      loading: 'Loading…',
      yourRep: 'Your Rep',
      myProfile: 'My Profile',
      favorites: 'Favorites',
      registeredOn: 'Joined on:',
      graduatedOn: 'Graduated on:',
      totalBadgesEarned: 'Total Badges Earned:',
      lastBookingLogged: 'Last Booking Logged:',
      currentTier: 'Current Tier',
      lastBadgeEarned: 'Last Badge Earned:',
      currentFocus: 'Current Focus:',
    },
    todaysfocus: {
      title: "Today's Focus",
      empty: 'No focus items for today',
      loading: 'Loading…',
      error: 'Something went wrong',
      slideNavAria: 'Slide navigation',
      slideAria: 'Slide',
      carouselAria: "Today's focus",
    },
    welcome: 'Welcome!',
    welcomeBack: 'Welcome back, {firstName}!',
    notifications: {
      loading: 'Loading…',
      empty: 'No notifications',
    },
    achievements: {
      title: 'Rewards & Contests',
      loading: 'Loading…',
      lastBooking: 'Last Entry Submission',
      currentTier: 'Current Tier',
      contestEntries: 'Total Contest Entries',
      nightsBooked: 'Nights Booked',
      totalRevenue: 'Total Revenue Reported',
      noBookingData: 'No booking data available.',
      fileUploadSuccess: 'File has been uploaded successfully.',
      quickSubmit: {
        title: 'Quick submit',
        uploading: 'Uploading…',
        clear: 'Clear',
        submit: 'Submit',
        submitSuccessSimulated: 'Booking submitted successfully',
      },
    },
  },
  notification: {
    newAndNow: 'New & Now!',
    alert: 'Alert',
    message: 'Message',
    badge: 'New Badge',
    contest: 'Contest',
    'content-update': 'Content Update',
    events: 'Events',
    other: 'Notification',
    welcome: 'Welcome',
  },
  profileImageView: {
    currentImage: 'Your current profile image:',
    uploadImage: 'Upload your profile image:',
    chooseAFile: 'Choose a file…',
    cancel: 'cancel',
    backButton: 'Go Back',
    uploadButton: 'Upload profile image',
    saveButton: 'Save this profile image',
    fileTooLargeTitle: 'Uploading size exceeded',
    fileTooLargeText: 'Max image upload size is 10mb',
  },
  loginScreen: {
    version2: {
      homeTitle:
        "Let's see if we can find an existing profile for you in our system.",
      homeTitleSub:
        'Enter the email address you typically use to login to training programs.',
      noAccount:
        'No account found ({email}), please try with another email or create an account now.',
      continueButton: 'Continue',
      success:
        'Successfully updated your account! You will be redirected shortly to the home page.',
      successNewAccount:
        'To complete your registration, you will receive a confirmation email to verify your account.',
      loginButton: 'Login',
      matchFound:
        'We have found a match, please fill in your password to continue.',
      magicLink: 'Login via a link in your email:',
      magicLinkButton: 'Request Magic Link',
      magicLinkTitle:
        'Get a direct link sent to your email that will sign you in instantly.',
      otherEmailButton: 'Submit',
      title:
        'Please take a moment to complete the information below to create a profile to begin your journey.',
      titleIndustry:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      register: 'Create an account',
      agent: 'Travel Advisor',
      visitor: 'Industry Visitor',
      step1: 'Step 1: Type of User',
      step2: 'Step 1: Create An Account',
      step3: 'Step 2: Create a Personal Profile',
      marketingOptIn:
        'Are you sure you are not interested in staying connected to this program’s travel trade team?',
      optIn: 'Yes, I’m Interested',
      optOut: 'Not Interested',
      step2Sub1: 'Tell Us About Yourself',
      step2Sub2: 'Tell Us About Your Employer',
      privacyHead: 'COMMUNICATIONS PREFERENCES',
      privacySub:
        'Check the boxes below to ensure you receive important communications from the supplier’s trade team networking and sales support initiatives.',
      privacy:
        'We protect your privacy and never sell, misuse or betray your trust.',
      store: 'Easily download this program at your app store:',
      powered: 'POWERED BY',
      toastMessage: {
        forgotSuccess:
          'We have e-mailed your password reset link! You will be redirected to the login page in 10 seconds.',
        emailNotExisting: "The email address you entered doesn't exist.",
        magicLinkMessage: 'Please wait, we are signing you in right now.',
        magicLinkError:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkError1:
          "We couldn't find a valid token, please login or request a new magic link. If this problem persists, please contact us at: info@travpromobile.com.",
        magicLinkError2:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkSuccess:
          "Check your email at {email}. It has a magic link that'll sign you in.",
        magicLinkErrorWait:
          'Please wait 5 minutes in between magic link requests.',
        emailNotFoundError:
          'The email address you entered can’t be found in our records. Please check for misspellings or create an account.',
      },
      errors: {
        zipCodeNotFound: 'ZipCode not found, try again',
        zipCodeOnlyNumbers: 'ZipCode can only contain numbers',
        password: 'Please enter a password',
        passwordNotMatching: 'The passwords you entered do not match',
        passwordTooShort: 'Password needs to be at least 8 characters',
        emailExists:
          'This email address already exists or is invalid. Please try with another email address or login to your account.',
        fillInAllFields: 'Please fill in all the required fields',
        fillInEmail: 'Please fill in your email.',
        emailNotExisting: "The email address you entered doesn't exist.",
      },
      fields: {
        forgotSubCopy: 'Forgot your password & want to change it? ',
        forgotSubCopy2:
          'Want to bypass password entirely? We will send you an email with a magic link that will automatically log you into the program. ',
        city: 'City',
        companyName: 'Company Name',
        role: 'Your Role',
        description: "Which best describes your company's business?",
        country: 'Country',
        password: 'Password',
        passwordRegister: 'Choose Password (8 character minimum)',
        passwordConfirm: 'Confirm Password',
        firstName: 'First Name (Given)',
        lastName: 'Last Name (Family)',
        agency: 'Employer Business Name',
        title: 'Your Role (Select One)',
        company: 'Company Name',
        select: 'Select an option below',
        state: 'State',
        province: 'Province/Region/State',
        zipCode: 'Zip Code',
        postalCode: 'Postal Code',
        affiliate: 'Which group is your MAIN agency affiliation?',
        hostAgency: 'Your Host Agency?',
        executive: 'Executive',
        management: 'Management',
        marketing: 'Marketing',
        sales: 'Sales',
        coordinator: 'Coordinator',
        other: 'Other',
        opt: "Stay connected to this program's travel trade team and receive updates.",
        optMarketing:
          'Stay connected to TravPRO regarding similar programs and events.',
        retail: 'Retail Store Front',
        home: 'Home-Based Agent',
        independent: 'Independent Contractor',
        host: 'Host Agency',
        call: 'Call Center or Web-Based Agency',
        describes: 'What best describes you and your agency’s business? ',
        title: 'Which Best Describes Your Role?',
        experience: 'How many years have you been local to the area you work?',
        popUpMessage:
          '<p> Thank you for your interest in <b>Travel Nevada Ambassador</b>. ' +
          'This is Travel Nevada’s online platform and resources center for frontline staff, to help you learn more about our beautiful state and provide customized recommendations for our visitors.</p>' +
          '<p>If you are a consumer, please visit the consumer website at:</p>' +
          '<a href="https://travelnevada.com/">https://travelnevada.com/</a>' +
          '<p>If you are a travel advisor, please visit the b2b training at:</p>' +
          '<a href="https://nvtrailblazers.travelnevada.com/">https://nvtrailblazers.travelnevada.com/</a>.',
      },
    },
    title: 'Travel Professional Training and Sales Enablement Program', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome to the',
      headerBottom: 'Travel Nevada Ambassador Program', // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Learn, Promote & Sell on the Go',
      1: 'Multi-media Training Across Devices',
      2: 'Certificate of Completion',
      3: 'Ready-made Sales Presentations',
      4: 'High-impact Promotional Materials',
      5: 'Insider Tips & Promotions',
      6: 'Real-time Product Directory',
      7: 'Timely News & Updates',
    },
    emailPrompt:
      'Please enter your email address and password to confirm that you are a travel professional.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    fields: {
      what: 'What type of travel do you sell?',
      what1: 'What is the #1 type of travel you sell?',
      what2: 'What is the #2 type of travel you sell?',
      what3: 'What is the #3 type of travel you sell?',
      agency: 'Agency *',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Confirm your password *',
      firstName: 'First name *',
      lastName: 'Last name *',
      agencyName: 'Agency Name *',
      city: 'City *',
      stateProvince: 'State / Province *',
      salutation: 'Salutation *',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      opt: "Stay In Touch! Yes, I'd like to opt in to communications from Travel Nevada that will keep me posted on news, events, incentives, FAM’s and more!",
      complete: 'Step 2: Complete your profile',
      tell: 'Tell Us About Yourself',
      title: 'Business Title *',
      host: 'Host Agency Name',
      country: 'Country / Region',
      select: 'Please select an option below',
      header2: 'Which segment(s) do you primarily sell?',
      step2: 'Describe Your Business',
      leisure: 'Leisure',
      corporate: 'Corporate',
      group: 'Group',
      affiliate: 'What is Your Main Affiliation?',
      forgot:
        'Forgot your password? Click the button below and we’ll send you an email to reset your password.',
    },
    noAgent: {
      noAgentButton: "I'm not an advisor",
      title: 'Thank you for your interest in Nevada.', // Product specific
      messageWeb:
        'The content on this site is exclusively for travel professionals. \n To learn more about Nevada, please visit: ', // Product specific
      messageMobile:
        "Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
    registered: 'This email is already registered',
    forgot: 'Reset Password',
    header:
      'Please take a moment to complete all the information below, as this is what will populate your profile and contact information.',
    step1: 'Step 1: Complete your email address and choose a password.',
  },
  welcomeScreen: {
    title: 'Welcome to Travel Nevada Ambassador', // Product specific
    helloUser: 'Hello {{name}}',
    hello: 'Hello,',
    fromAgency: 'from {{agency}}',
    notUser: 'Not {{name}}?',
    introOnline:
      "Train immediately online or preload the content so it's always available for offline use!",
    introOffline:
      'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start learning',
    continueTraining: 'Continue learning',
    graduated: 'Congratulations!',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initializing...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    start: 'Start',
    continue: 'Continue',
    review: 'Review',
    restart: 'Restart',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Complete',
    unlock: 'Unlock this chapter by completing training chapter {number}.',
    unlockSpecialization: 'Unlock this chapter by completing The Foundation',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    allUnlocked: 'You have unlocked all chapters!',
    certificate: 'Certificate',
    courseComplete: 'Continue',
    endReached: "You've reached the end",
    retainEnd:
      'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    watchListenRead: 'Watch, Listen & Read more',
    trouble:
      "It looks like you're having trouble, please re-read the content on the previous page(s) and try again.",
    confirm: 'Confirm your answer',
    choose: 'Please choose an answer',
    skip: 'Return >',
    status: 'Current Status:',
    viewAllTitle: 'Training Tip',
    viewAll:
      'In order to proceed to the next page, please click on the icons to view the supplementary content. Videos, maps and other helpful information have been provided to enhance your training and ensure you achieve PRO status.',
    fillBlanks: 'Fill in the blank(s):',
    next: 'Next question',
    retry: 'Try Again',
    fastTrackText: {
      success:
        "Congratulations, you've passed the Fast Track course and unlocked the rest of the training!",
      failed:
        "Unfortunately you didn't pass the Fast Track course, you can resume your training to earn your diploma!",
    },
    fastTrack: 'Become a Swiss Travel Superstar!',
    fastTrackExplanation:
      'Simply take the quiz on the following pages for your chance to win a FAM to Switzerland!<br><br><span style="font-weight: bold">You will find all answers to the quiz questions in the following ways:</span><br><br>1. The content that you learned in the Rail Europe and Switzerland modules<br><br>2. And on the following websites:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">Be sure to review these resources in detail before taking the quiz! Only those with the highest of scores will have the chance to be invited to the FAM.</span>',
    fastTrackButton: 'Click Here to Take the Swiss Superstar Quiz',
    grading: 'Your final grade is: {grade}%',
    // status: "Current Status:",
    badge: 'download \n badge',
  },
  points: {
    completed: '{completed} / {total} Completed',
  },
  nav: {
    home: 'Home',
    train: 'Train',
    learn: 'Learn',
    retain: 'Retain',
    directory: 'Directory',
    showRoom: 'Showcases',
    showcases: 'Showcases',
    offers: 'Offers',
    promote: 'Resources',
    sell: 'Sell',
    info: 'Info',
    achievements: 'Achievements',
    media: 'Media',
    favorites: 'Favorites',
    contact: 'Meet the Team',
    reportCard: 'View Diploma',
    accountSettings: 'Account Settings',
    messages: 'Messages',
    search: 'Search',
    resources: 'Resources',
  },
  contentHeaders: {
    train: 'Train',
    retain: 'Retain',
    subapps: 'Travel Nevada Ambassador Partner Modules',
    maintrainings: 'The Foundation',
    subtrainings: 'Nevada Road Trips',
  },
  pageDescriptions: {
    train: 'Educate, engage and become the expert.',
    showroom: '',
    retain:
      'Welcome to Retain. After completing your training, this will be your your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device.',
    promote:
      'Here you’ll find resources to keep you up to date on tourism essentials, as well as interesting items to share with visitors and help them experience the best of the destination.',
    sell: 'Answer client questions and close the sale like a pro with deep resources and targeted sales support.',
    favorites: 'Check out your personally favorited content',
    search: 'Look through all content',
    subapps: '',
    maintrainings:
      'Complete these essential chapters to earn your diploma and achieve Bronze status! ',
    subtrainings:
      'Cruise through five of these chapters to get to Silver status and cross the finish line with all ten to become a Gold Travel Nevada Ambassador!',
  },
  general: {
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    previous: 'Previous',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    page: 'Page',
    search: 'Search',
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResultsFor: 'No results have been found for: {{query}}',
    noFavorites: "You don't have any favorites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: 'Results for: {{query}}',
    showAll: 'Show all',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    complete: 'Continue',
    courseComplete: 'Chapter Complete!',
    chapterComplete: 'Chapter Completed!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt-out',
    settings: 'Privacy Settings',
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message:
      'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource on your favorite social media!',
    download: 'Download',
  },
  sharing: {
    copyURL: 'Copy Link',
    copied: 'Copied',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: 'Get the full experience in the app',
    body: 'Download the app by tapping a button below, or search "{appName}" in your app store.',
    benefits: {
      header: 'With the app, you can:',
      1: 'Train anytime, anywhere, even without Wi‑Fi',
      2: 'Access sales tools and resources in one place',
      3: 'Pick up where you left off on any device',
    },
    desktop: 'Prefer a bigger screen? Visit {link} on your desktop or laptop.',
  },
  directoryView: {
    search: 'Search...',
    amountOfResults: 'Amount of results:',
    filter: 'Filter',
    filters: 'Filters:',
    resetFilters: 'Reset Filters',
    showResults: 'Show Results',
    noResults: 'No results found. Please try with a different search.',
    resetMap: 'Reset Map to Start >',
    viewNow: 'View Now >',
  },

  preregisterview: {},
  rewards: {
    rewards: 'Rewards',
    title: 'Welcome to the Achievements Center',
    subheader:
      'Track your training achievements, redeem your rewards and share your certifications.',
    button: 'Submit your booking',
    products: 'Marketplace',
    viewAllBookings: 'Bookings',
    viewLeaderboard: 'Leaderboard',
    viewDashboard: 'Points Dashboard',
    viewRewards: 'Overview',
    home: {
      entries: 'Current Entries',
      trainingAchievements: 'TRAINING ACHIEVEMENTS',
      trainingAchievementsText:
        'Track your training progress, certifications, and metallic rewards status on this page. You’ll also be able to download and share your diploma, as well as any badges you’ve earned.',
      bookingContests: 'BOOKINGS DASHBOARD',
      bookingContestsText:
        'Easily track and manage current booking submissions on the Bookings Dashboard. ',
      submitBooking: 'SUBMIT BOOKINGS',
      submitBookingText:
        'This is where you’ll submit bookings for inclusion in booking contests.',
      currentContest: 'CURRENT CONTEST',
      currentContests: 'CURRENT CONTESTS',
      contestHeader: 'Win cash prizes on bookings each month!',
      contestSeeOther: 'See other ',
      contestTerms: 'Terms & Conditions',
      noContest: 'Not available.',
    },
    bookingRewardsView: {
      title: 'Marketplace',
    },
    bookingsView: {
      title: 'Bookings',
    },
    leaderboardScreen: {
      title: 'POINTS \n Leaderboard',
      earnedpts: 'MY POINTS EARNED​:',
      pointsWall: 'POINTS TOP 5 TRACKER​:',
      startEarning: "Start now earning XP's and join the leaderboard!",
      prizes: 'Prizes',
      tAndC: 'Terms and Conditions apply*',
      pointsOverview: {
        title: 'How to earn points',
        booths: 'Visit Exhibitor Showcases',
        breakoutSessions: 'Attend Breakout Sessions & Destination Spotlights',
        trainingSessions: 'Complete a Training Chapter',
        adventureSpotlights: 'Family Travel Tips',
        share: 'Sharing Content',
        shareMax: '(up to {maxSharePoints} points)',
        shareInfo:
          'Sharing is counted by sharing booth content to Twitter and Facebook or sharing the entire booth with colleagues or clients.',
        viewVideo: 'View Video',
      },
    },
    dashboardView: {
      title: 'Bookings Dashboard',
      subtitle: 'Track and Manage Your Booking Entries Here.',
      badge: 'Badges',
      activity: 'Bookings Dashboard',
      manage: 'Manage Bookings',
      manageSub:
        'Sort using buttons above and click any record to manage submission details. All pending entries will be verified within 72 hours. ',
      noBookings: 'There are no records to display.',
      state: {
        approvedEntries: 'Approved Entries',
        pendingEntries: 'Pending Entries',
        declinedEntries: 'Declined Entries',
        viewAll: 'View All',
      },
    },
    bookingForm: {
      title: 'Booking Submission Form',
      subTitle: 'Enter your booking:',
      required: '* Indicates a required field',
      email: 'Agent Email',
      agentFirstName: 'Agent First Name',
      agentLastName: 'Agent Last Name',
      company: 'Company name',
      iata: 'IATA/CLIA #',
      stateProvince: 'State/ Province',
      postalCode: 'Zip Code *',
      country: 'Country',
      bookingNumber: 'Booking Confirm Number',
      numberOfGuests: 'Number of Adult Guests',
      bookingDate: 'Booking Date',
      tourOperator: 'Tour Operator / Booking Method',
      firstName: 'First Name',
      lastName: 'Guest Last Name',
      accommodation: 'Resort/Hotel/Accommodations booked',
      select: 'Select an option',
      wholesaler:
        'Wholesaler Name (if applicable): if this is a direct booking, enter NONE',
      arrivalDate: 'Check-In Date',
      departureDate: 'Check-Out Date',
      lengthOfStay: 'Length of Stay (in Nights)',
      reservationNumber: 'Reservation Number',
      rooms: 'Number of Rooms',
      stay: 'Length of Stay (in Nights)',
      airline: 'Airline / Carrier (2- digit code)',
      originAirport: 'Origin Gateway (3- letter airport code)',
      destination: 'Destination/ island (3- letter airport code)',
      cost: 'Total Cost of Booking (only use decimals)',
      file: 'RezSnap™ Proof Upload',
      disclaimer: '* Required fields',
      button: 'Submit your booking',
      sub: 'Your information',
      sub2: 'Booking information',
      guests: 'Number of Passengers',
    },
    TermsAndConditions: {
      title: 'Terms and Conditions',
      button: 'Return to Rewards',
    },
    thankYouPage: {
      thanks: 'Thank you',
      congrats: 'Congratulations, ',
      body: 'your booking has been received and sent to the campaign supervisor for verification.',
    },
    menu: {
      home: 'Overview',
      achievements: 'Training\nAchievements',
      bookings: 'Bookings\nDashboard',
      form: 'Submit\nBookings',
    },
  },
  badgeView: {
    title: 'Training Achievements',
    subtitle:
      'Track your training progress, certifications, and metallic tier status on this page. You’ll also be able to download and share your Travel Nevada Ambassador diploma, as well as any badges you’ve earned.',
    badgeDisplayTitle: 'Metallic Achievement Status',
    badgeAchievement:
      'You have achieved {rank} Status! Click the icon on the right to view and share your status.',
    bronze: 'Bronze',
    silver: 'Silver',
    gold: 'Gold',
    platinum: 'Platinum',
    complete: 'COMPLETE',
    diploma: 'Diploma',
    chapterBadges: 'Specialization Badges',
    partnerBadges: 'Partner Badges',
    tierRewards: 'Tier Rewards',
    click: 'Click',
    here: 'here',
    bronzeReward: 'to access your exclusive BRONZE reward.',
    silverReward: 'to access your exclusive SILVER reward.',
    goldReward: 'to access your exclusive GOLD reward.',
  },
  custom: {
    splitUsers: 'I Am A ...',
    brandAmbassador: 'Brand Ambassador',
    travelPro: 'Travel Professional',
  },
  directory: {
    open: 'Open',
    close: 'Close',
    filters: 'Filters',
    filter: 'Filter',
    subFilter: 'Sub Filter',
    reset: 'Reset Filters',
    other: 'Other',
    view: 'View Now',
    attractions: 'Attractions',
    accommodations: 'Accommodations',
    dining: 'Dining',
    nightlife: 'Nightlife',
    history: 'History/Heritage',
    artsculturehistory: 'Arts, Culture & History',
    themeparks: 'Theme Parks',
    foodbeverage: 'Food & Beverage',
    sportsrecreationoutdoors: 'Outdoor/Sports & Recreation',
    otheraccommodations: 'Other Accommodations',
    shopping: 'Shopping',
    weddingservices: 'Wedding Services',
    medicalservices: 'Medical Services',
    golf: 'Golf',
    transportationservices: 'Transportation Services',
    spas: 'Spas',

    amount: 'Amount of Results',
    museums: 'Museums',
    thingstodo: 'Things to Do',
    placestostay: 'Places to Stay',
    outdoorrecreation: 'Outdoor Recreation',
    ghosttowns: 'Ghost Towns',
    shoppingleisure: 'Shopping & Leisure',
    fooddrink: 'Food & Drink',
    weirdnevada: 'Weird Nevada',
    weddingsevents: 'Weddings & Events',
    artphotographygalleries: 'Art & Photography Galleries',
    boatingonthewater: 'Boating & On the Water',
    divingsnorkeling: 'Diving & Snorkeling',
    sightseeingtoursunsetcruises: 'Sightseeing Tours & Sunset Cruises',
    ecoturskayakingpaddleboarding: 'EcoTours, Kayaking, Paddleboarding',
    fishing: 'Fishing',
    beachesparksgardens: 'Beaches, Parks, Gardens',
    recreation: 'Recreation',
    museumshistoricsites: 'Museums & Historic Sites',
    vehiclebikerentals: 'Vehicle & Bike Rentals',
    wildlifeencounters: 'Wildlife Encounters',
    performingarts: 'Performing Arts',
    hotelsmotelsresorts: 'Hotels, Motels, Resorts',
    vacationrentals: 'Vacation Rentals',
    innsbbsguesthouses: 'Inns, B&Bs, Guesthouses',
    campingrvscampgrounds: 'Camping, RVs, Campgrounds',
    uniquestays: 'Unique Stays',
    rvparkscamping: 'RV Parks & Camping',
    hotelslodging: 'Hotels & Lodging',
    resortscasinos: 'Resorts & Casinos',
    craftbeverages: 'Craft Beverages',
    barssaloons: 'Bars & Saloons',
    restaurants: 'Restaurants',
    localartscene: 'Local Art Scene',
    wildlifenature: 'Wildlife & Nature',
    offroadingadventure: 'Off-Roading & Adventure',
    hikingtrails: 'Hiking & Trails',
    watersportsfishing: 'Water Sports & Fishing',
    spawellness: 'Spa & Wellness',
    liveperformances: 'Live Performances',
    hotelslodginguniquestays: 'Hotels & Lodging, Unique Stays',
    uniquestaysrvparkscamping: 'Unique Stays, RV Parks & Camping',
    uniquestayshotelslodging: 'Unique Stays, Hotels & Lodging',
    hotelslodgingrvparkscamping: 'Hotels & Lodging, RV Parks & Camping',
    localartscenehotelslodginguniquestays:
      'Local Art Scene, Hotels & Lodging, Unique Stays',
    wildlifenaturehotelslodgingoffroadingadventurervparkscampinguniquestays:
      'Wildlife & Nature, Hotels & Lodging, Off-Roading & Adventure, RV Parks & Camping, Unique Stays',
    uniquestayscraftbeverages: 'Unique Stays, Craft Beverages',
    uniquestayshotelslodgingresortscasinos:
      'Unique Stays, Hotels & Lodging, Resorts & Casinos',
    restaurantshotelslodginguniquestaysrvparkscamping:
      'Restaurants, Hotels & Lodging, Unique Stays, RV Parks & Camping',
    wildlifenaturehotelslodgingshoppinguniquestays:
      'Wildlife & Nature, Hotels & Lodging, Shopping, Unique Stays',
    rvparkscampinguniquestays: 'RV Parks & Camping, Unique Stays',
    uniquestaysrvparkscampingbarssaloons:
      'Unique Stays, RV Parks & Camping, Bars & Saloons',
    restaurantshotelslodging: 'Restaurants, Hotels & Lodging',
    hotelslodgingresortscasinos: 'Hotels & Lodging, Resorts & Casinos',
    resortscasinosshopping: 'Resorts & Casinos, Shopping',
    wildlifenatureresortscasinosshopping:
      'Wildlife & Nature, Resorts & Casinos, Shopping',
    wildlifenaturehotelslodgingresortscasinosshopping:
      'Wildlife & Nature, Hotels & Lodging, Resorts & Casinos, Shopping',
    hotelslodgingshopping: 'Hotels & Lodging, Shopping',
    uniquestayshotelslodgingrvparkscamping:
      'Unique Stays, Hotels & Lodging, RV Parks & Camping',
    hotelslodgingrestaurantsrvparkscamping:
      'Hotels & Lodging, Restaurants, RV Parks & Camping',
    watersportsfishingwildlifenature:
      'Water Sports & Fishing, Wildlife & Nature',
    rvparkscampinghikingtrails: 'RV Parks & Camping, Hiking & Trails',
    rvparkscampingwatersportsfishinghikingtrailswildlifenature:
      'RV Parks & Camping, Water Sports & Fishing, Hiking & Trails, Wildlife & Nature',
    rvparkscampingwatersportsfishing:
      'RV Parks & Camping, Water Sports & Fishing',
    hikingtrailswildlifenature: 'Hiking & Trails, Wildlife & Nature',
    shoppingwatersportsfishing: 'Shopping, Water Sports & Fishing',
    offroadingadventurewildlifenature:
      'Off-Roading & Adventure, Wildlife & Nature',
    offroadingadventureshopping: 'Off-Roading & Adventure, Shopping',
    rvparkscampinghikingtrailswildlifenature:
      'RV Parks & Camping, Hiking & Trails, Wildlife & Nature',
    wildlifenaturehikingtrailsoffroadingadventure:
      'Wildlife & Nature, Hiking & Trails, Off-Roading & Adventure',
    wildlifenatureshopping: 'Wildlife & Nature, Shopping',
    wildlifenaturehikingtrails: 'Wildlife & Nature, Hiking & Trails',
    hikingtrailsoffroadingadventurewildlifenature:
      'Hiking & Trails, Off-Roading & Adventure, Wildlife & Nature',
    rvparkscampingwildlifenaturehikingtrailswatersportsfishing:
      'RV Parks & Camping, Wildlife & Nature, Hiking & Trails, Water Sports & Fishing',
    wildlifenatureoffroadingadventure:
      'Wildlife & Nature, Off-Roading & Adventure',
    hikingtrailsoffroadingadventureshopping:
      'Hiking & Trails, Off-Roading & Adventure, Shopping',
    rvparkscampingwildlifenaturewatersportsfishinghikingtrails:
      'RV Parks & Camping, Wildlife & Nature, Water Sports & Fishing, Hiking & Trails',
    rvparkscampingwildlifenaturehikingtrails:
      'RV Parks & Camping, Wildlife & Nature, Hiking & Trails',
    rvparkscampingwildlifenaturewatersportsfishing:
      'RV Parks & Camping, Wildlife & Nature, Water Sports & Fishing',
    rvparkscampingwildlifenatureoffroadingadventure:
      'RV Parks & Camping, Wildlife & Nature, Off-Roading & Adventure',
    rvparkscampinghikingtrailsoffroadingadventurewildlifenature:
      'RV Parks & Camping, Hiking & Trails, Off-Roading & Adventure, Wildlife & Nature',
    rvparkscampingoffroadingadventurewildlifenatureuniquestays:
      'RV Parks & Camping, Off-Roading & Adventure, Wildlife & Nature, Unique Stays',
    rvparkscampingoffroadingadventurewatersportsfishingwildlifenature:
      'RV Parks & Camping, Off-Roading & Adventure, Water Sports & Fishing, Wildlife & Nature',
    wildlifenaturewatersportsfishing:
      'Wildlife & Nature, Water Sports & Fishing',
    rvparkscampinghikingtrailswildlifenatureoffroadingadventure:
      'RV Parks & Camping, Hiking & Trails, Wildlife & Nature, Off-Roading & Adventure',
    rvparkscampingwatersportsfishingoffroadingadventure:
      'RV Parks & Camping, Water Sports & Fishing, Off-Roading & Adventure',
    watersportsfishingrestaurantsshopping:
      'Water Sports & Fishing, Restaurants, Shopping',
    rvparkscampingwatersportsfishinghikingtrailsoffroadingadventurewildlifenature:
      'RV Parks & Camping, Water Sports & Fishing, Hiking & Trails, Off-Roading & Adventure, Wildlife & Nature',
    rvparkscampingwatersportsfishinghikingtrailsoffroadingadventure:
      'RV Parks & Camping, Water Sports & Fishing, Hiking & Trails, Off-Roading & Adventure',
    offroadingadventurehikingtrails: 'Off-Roading & Adventure, Hiking & Trails',
    wildlifenatureshoppingwatersportsfishing:
      'Wildlife & Nature, Shopping, Water Sports & Fishing',
    rvparkscampingwatersportsfishingwildlifenature:
      'RV Parks & Camping, Water Sports & Fishing, Wildlife & Nature',
    wildlifenaturehotelslodging: 'Wildlife & Nature, Hotels & Lodging',
    hikingtrailsoffroadingadventure: 'Hiking & Trails, Off-Roading & Adventure',
    watersportsfishinghikingtrailswildlifenature:
      'Water Sports & Fishing, Hiking & Trails, Wildlife & Nature',
    offroadingadventurewatersportsfishing:
      'Off-Roading & Adventure, Water Sports & Fishing',
    wildlifenatureresortscasinos: 'Wildlife & Nature, Resorts & Casinos',
    wildlifenaturerestaurantsshopping:
      'Wildlife & Nature, Restaurants, Shopping',
    hikingtrailswatersportsfishingoffroadingadventure:
      'Hiking & Trails, Water Sports & Fishing, Off-Roading & Adventure',
    watersportsfishingrvparkscamping:
      'Water Sports & Fishing, RV Parks & Camping',
    rvparkscampingwatersportsfishinghikingtrails:
      'RV Parks & Camping, Water Sports & Fishing, Hiking & Trails',
    hikingtrailsshoppingwatersportsfishing:
      'Hiking & Trails, Shopping, Water Sports & Fishing',
    hikingtrailswildlifenaturewatersportsfishing:
      'Hiking & Trails, Wildlife & Nature, Water Sports & Fishing',
    wildlifenatureoffroadingadventureshopping:
      'Wildlife & Nature, Off-Roading & Adventure, Shopping',
    rvparkscampingshoppingwildlifenature:
      'RV Parks & Camping, Shopping, Wildlife & Nature',
    rvparkscampinghikingtrailsoffroadingadventure:
      'RV Parks & Camping, Hiking & Trails, Off-Roading & Adventure',
    rvparkscampinghikingtrailswildlifenatureoffroadingadventurewatersportsfishing:
      'RV Parks & Camping, Hiking & Trails, Wildlife & Nature, Off-Roading & Adventure, Water Sports & Fishing',
    wildlifenaturemuseums: 'Wildlife & Nature, Museums',
    museumswildlifenature: 'Museums, Wildlife & Nature',
    museumsshopping: 'Museums, Shopping',
    localartscenemuseums: 'Local Art Scene, Museums',
    offroadingadventuremuseums: 'Off-Roading & Adventure, Museums',
    museumsoffroadingadventure: 'Museums, Off-Roading & Adventure',
    wildlifenaturemuseumsoffroadingadventure:
      'Wildlife & Nature, Museums, Off-Roading & Adventure',
    museumsuniquestays: 'Museums, Unique Stays',
    wildlifenaturemuseumswatersportsfishing:
      'Wildlife & Nature, Museums, Water Sports & Fishing',
    restaurantsshopping: 'Restaurants, Shopping',
    shoppinglocalartsceneoffroadingadventure:
      'Shopping, Local Art Scene, Off-Roading & Adventure',
    shoppingwildlifenature: 'Shopping, Wildlife & Nature',
    spawellnessshopping: 'Spa & Wellness, Shopping',
    localartscenerestaurantsshopping: 'Local Art Scene, Restaurants, Shopping',
    localartscenewildlifenaturerestaurantsshopping:
      'Local Art Scene, Wildlife & Nature, Restaurants, Shopping',
    shoppinglocalartscene: 'Shopping, Local Art Scene',
    localartsceneshopping: 'Local Art Scene, Shopping',
    localartsceneliveperformances: 'Local Art Scene, Live Performances',
    localartscenewildlifenatureliveperformances:
      'Local Art Scene, Wildlife & Nature, Live Performances',
    localartscenewildlifenature: 'Local Art Scene, Wildlife & Nature',
    localartsceneuniquestays: 'Local Art Scene, Unique Stays',
    restaurantsbarssaloons: 'Restaurants, Bars & Saloons',
    restaurantscraftbeverages: 'Restaurants, Craft Beverages',
    restaurantsshoppingcraftbeverages: 'Restaurants, Shopping, Craft Beverages',
    restaurantsshoppingwildlifenature:
      'Restaurants, Shopping, Wildlife & Nature',
  },
  search: {
    pages: 'Pages',
    resources: 'Resources',
  },
};
